import {
  INTERVENTION_TEMPLATE_INCLUDES,
  useGetInterventionTemplate,
} from "@/entities/intervention-template";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import InterventionTemplateEdit from "./InterventionTemplateEdit.component";

const include = [
  INTERVENTION_TEMPLATE_INCLUDES.REVISION,
  INTERVENTION_TEMPLATE_INCLUDES.REFERENCE_REVISION,
].join(",");

const InterventionTemplateEditWrapper = ({ templateId }) => {
  const { template, isLoading } = useGetInterventionTemplate(templateId, {
    params: { include },
  });

  return (
    <FetchItemWrapper
      item={template}
      loading={isLoading}
      renderContent={(template) => (
        <InterventionTemplateEdit model={template} />
      )}
    />
  );
};

export default InterventionTemplateEditWrapper;
